import ReactDOM from 'react-dom';
import React from 'react';
import { Provider } from 'react-redux';
import storeDesktop, { rootActionsDesktop, useAppDispatchDesktop, useAppSelectorDesktop } from './data/store-desktop';
import storeMobile, { useAppSelectorMobile, rootActionsMobile, useAppDispatchMobile } from './data/store-mobile';
import TopMiniCart, { UPDATE_COUNT_VALUE_ONLY_EVENT, UPDATE_MINI_CART_COUNT_EVENT } from './ui/main';
import { getTopMiniCartCount } from './data/data-service';

export interface IStoreProps {
    useAppSelector: typeof useAppSelectorDesktop,
    rootActions: typeof rootActionsDesktop,
    useAppDispatch: typeof useAppDispatchDesktop,
}

export const initTopMiniCart = () => {

    document.addEventListener(UPDATE_MINI_CART_COUNT_EVENT, async () => {
        const response = await getTopMiniCartCount();

        if(!response ||
            response.statusCode !== 200 ||
            !response.data.isValid){
            return;
        }

        const count = response.data.relatedData || 0;
        document.dispatchEvent(new CustomEvent(UPDATE_COUNT_VALUE_ONLY_EVENT, {
            detail: count,
        }));
    });

    const $rootDesktop = document.getElementById('header-minicart-placeholder');
    if (!$rootDesktop) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ storeDesktop }>
                <TopMiniCart
                    isMobile={ false }
                    storeProps={{
                        useAppSelector: useAppSelectorDesktop,
                        rootActions: rootActionsDesktop,
                        useAppDispatch: useAppDispatchDesktop,
                    }}
                />
            </Provider>
        </React.StrictMode>,
        $rootDesktop
    );

    const $rootMobile = document.getElementById('header-minicart-m-placeholder');
    if (!$rootMobile) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={ storeMobile }>
                <TopMiniCart
                    isMobile={ true }
                    storeProps={{
                        useAppSelector: useAppSelectorMobile,
                        rootActions: rootActionsMobile,
                        useAppDispatch: useAppDispatchMobile,
                    }}
                />
            </Provider>
        </React.StrictMode>,
        $rootMobile
    );
};